import * as Immutable from "immutable";
import fetch from "logic/rest/FetchProvider";
import FieldTypeMapping from "views/logic/fieldtypes/FieldTypeMapping";
import URLUtils from "util/URLUtils";
import SearchExecutionState from "views/logic/search/SearchExecutionState";
import ParameterBinding from "views/logic/parameters/ParameterBinding";
import GlobalOverride from "views/logic/search/GlobalOverride";
import { reportingUrl } from "report/Constants";
export const migrateWidgetValueResult = (value) => {
  var _a, _b;
  return {
    calculatedAt: value.calculated_at,
    result: value.result,
    types: Immutable.List(value.field_types.map((json) => FieldTypeMapping.fromJSON(json))),
    hasError: ((_a = value.errors) == null ? void 0 : _a.length) > 0,
    errorMessage: (_b = value.errors) == null ? void 0 : _b.map((e) => e.description).join("\n")
  };
};
const migrateWidgetResult = (widgetValue) => ({
  ...widgetValue,
  result: migrateWidgetValueResult(widgetValue.result)
});
const migrateParameterBindings = (parameterValues) => Immutable.Map(
  Object.entries(parameterValues != null ? parameterValues : {}).map(([key, value]) => [key, ParameterBinding.forValue(value)])
);
export const fetchAdhocReportValues = async (widgets, parameterValues, timerangeOverride, now) => {
  const parameterBindings = migrateParameterBindings(parameterValues);
  const executionState = SearchExecutionState.create(
    parameterBindings,
    GlobalOverride.builder().timerange(timerangeOverride).now(now).build()
  );
  const results = await fetch("POST", URLUtils.qualifyUrl(reportingUrl("values")), {
    widgets,
    execution_state: executionState
  });
  return results.map(migrateWidgetResult);
};
export default fetchAdhocReportValues;
